export default __webpack_public_path__ + "static/media/digiDownloadBtn.7db09328.svg";